import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import {
  FormRadio,
  Headline,
  If,
  istEnumAuswahl,
  istNichtEnumAuswahl,
  istNeinAuswahl,
  FormMask,
  FormInput,
  FormSelect,
  Message,
  EnumTarifart,
  trEnv,
  appActions,
  BankIbanFormKonto,
  BankIbanFormMask,
  BankInhaberFormInput,
  BankSepaFormCheck,
  BankZahlartFormRadio,
  BankBemerkungFormText,
  DatenschutzFormCheck,
  SummingUp,
  Vertreterauswahl,
  Vertretersuchform,
  PrevNextButton,
  SpeicherButton,
  useNextPage,
  useUpdateAndValidateOnChange,
  useUpdateAndValidateIBANOnChange,
  actions,
  AbweichenderREFormRadio,
  AdresseForm,
} from 'ion-lib';
import { Col, Form, Row } from 'react-bootstrap';
import { getBannerFileName } from '../../helper';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';

const Zahlungsdaten = () => {
  const dispatch = useDispatch();
  const bankVerbindung = useSelector((state) => state.daten.bankVerbindung);
  const abwRechnungsempfaenger = useSelector((state) => state.daten.abwRechnungsempfaenger);
  const abweichenderRE = useSelector((state) => state.daten.abweichenderRE);
  const suchfeld = useSelector((state) => state.daten.vertretersuche.suchfeld);
  const kundenstatus = useSelector((state) => state.daten.kundenstatus);
  const auswahl = useSelector((state) => state.daten.vertretersuche.auswahl);
  const tarifart = useSelector((state) => state.daten.tarifart);

  const updateAndValidateOnChange = useUpdateAndValidateOnChange(0);
  const validateOnChange = useUpdateAndValidateOnChange();
  const validateIBANOnChange = useUpdateAndValidateIBANOnChange(0);
  const [zahlartClick, setZahlartClick] = useState(false);
  const nextPage = useNextPage();

  const handleNextClick = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'datenschutz',
      'bankVerbindung.inhaber',
      'bankVerbindung.sepa',
      'bankVerbindung.iban',
      'bankVerbindung.zahlart',
      'vertretersuche.auswahl.id',
      'vertretersuche.auswahl.name',
      'vertretersuche.auswahl.strasse',
      'vertretersuche.auswahl.plz',
      'vertretersuche.auswahl.typ',
      'vertretersuche.auswahl.ort',
      'abwRechnungsempfaenger.bankVerbindung.iban',
      'abwRechnungsempfaenger.anrede',
      'abwRechnungsempfaenger.email',
      'abwRechnungsempfaenger.geburtsdatum',
      'abwRechnungsempfaenger.hausnummer',
      'abwRechnungsempfaenger.nachname',
      'abwRechnungsempfaenger.ort',
      'abwRechnungsempfaenger.postleitzahl',
      'abwRechnungsempfaenger.strasse',
      'abwRechnungsempfaenger.telefonNummer',
      'abwRechnungsempfaenger.titel',
      'abwRechnungsempfaenger.vorname',
      'abwRechnungsempfaenger.zustellvermerk',
      'bemerkung',
      'kundenstatus',
    ], () => {
      if (trEnv.stationaer) {
        dispatch(appActions.holeVorbelegungenBeratungsdoku(() => {
          nextPage();
        }));
        return;
      }

      nextPage();
    }));
  };

  const vertreterSave = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'vertretersuche.auswahl.id',
      'vertretersuche.auswahl.name',
      'vertretersuche.auswahl.strasse',
      'vertretersuche.auswahl.plz',
      'vertretersuche.auswahl.typ',
      'vertretersuche.auswahl.ort',
    ]));
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel">
          <If predicate={kundenstatus.relevant}>
            <FormRadio
              {...kundenstatus}
              label="Sind Sie bereits unser Kunde?"
              name="daten.kundenstatus.value"
              className="mb-5"
              onChange={updateAndValidateOnChange}
            />
          </If>

          <If predicate={auswahl.id.relevant}>

            <Vertreterauswahl
              title={(!suchfeld.relevant || trEnv.ifiliale)
                ? 'Ihr Ansprechpartner rund um Ihren Vertrag'
                : 'Von wem möchten Sie bei Fragen rund um Ihre Hausratversicherung betreut werden?'}
              subtitle={(suchfeld.relevant && !trEnv.sparkasse) && <span dangerouslySetInnerHTML={{ __html: i18next.t('zahlungsdaten.datenschutzLink') }} />}
              className="mb-5"
              labelClassName="mb-3 sp-pt-3"
              onChange={({ target }) => {
                dispatch(actions.updateByList(
                  {
                    'daten.vertretersuche.auswahl.name.value': target.dataset.name,
                    'daten.vertretersuche.auswahl.strasse.value': target.dataset.strasse,
                    'daten.vertretersuche.auswahl.plz.value': target.dataset.plz,
                    'daten.vertretersuche.auswahl.ort.value': target.dataset.ort,
                    'daten.vertretersuche.auswahl.typ.value': target.dataset.typ,
                    'daten.vertretersuche.auswahl.id.value': target.value,
                  },
                  () => {
                    vertreterSave();
                    dispatch(appActions.holeBeratersuche());
                  },
                ));
              }}
              onRemove={() => {
                dispatch(actions.updateByList(
                  {
                    'daten.vertretersuche.auswahl.name.value': '',
                    'daten.vertretersuche.auswahl.strasse.value': '',
                    'daten.vertretersuche.auswahl.plz.value': '',
                    'daten.vertretersuche.auswahl.ort.value': '',
                    'daten.vertretersuche.auswahl.typ.value': '',
                    'daten.vertretersuche.auswahl.id.value': '',
                    'daten.vertretersuche.suchfeld.value': '',
                  },
                  () => {
                    dispatch(appActions.holeBeratersuche());
                  },
                ));
              }}
            />
            <Vertretersuchform
              onChange={(val) => dispatch(actions.updateByList(
                {
                  'daten.vertretersuche.auswahl.name.value': val.length ? val[0].name.value : '',
                  'daten.vertretersuche.auswahl.strasse.value': val.length ? val[0].strasse.value : '',
                  'daten.vertretersuche.auswahl.plz.value': val.length ? val[0].plz.value : '',
                  'daten.vertretersuche.auswahl.ort.value': val.length ? val[0].ort.value : '',
                  'daten.vertretersuche.auswahl.typ.value': val.length ? val[0].typ.value : '',
                  'daten.vertretersuche.auswahl.id.value': val.length ? val[0].id.value : '',
                },
                () => {
                  dispatch(appActions.holeBeratersuche());
                },
              ))}
            />
          </If>

          <If predicate={trEnv.stationaer}>
            <Headline>Wie möchten Sie zahlen?</Headline>
            <div
              onClick={() => setZahlartClick(true)}
              className="mb-5"
            >
              <BankZahlartFormRadio
                onChange={updateAndValidateOnChange}
              />
              <If predicate={!bankVerbindung.zahlart.ueberschreibbar && istEnumAuswahl(tarifart, EnumTarifart.VERBUND) && zahlartClick}>
                <Message
                  className="mt-n4 mb-5 arrow-top-scnd-left"
                  show
                  dismissible={false}
                  text={`<p>${i18next.t('zahlungsdaten.zahlart_alert')}</p>`}
                />
              </If>
              <If predicate={!bankVerbindung.zahlart.ueberschreibbar && istNichtEnumAuswahl(tarifart, EnumTarifart.VERBUND) && zahlartClick}>
                <Message
                  className="mt-n2 mb-5 arrow-top-scnd-left"
                  show
                  dismissible={false}
                  text="<p>Bei einer monatlichen Zahlweise ist die Zahlung per Rechnung nicht möglich.</p>"
                />
              </If>
            </div>
          </If>

          <AbweichenderREFormRadio />

          <If predicate={abwRechnungsempfaenger.vorname.relevant}>
            <Headline>Rechnungsempfänger / Kontoinhaber</Headline>
            <Form>
              <Row>
                <FormRadio
                  {...abwRechnungsempfaenger.anrede}
                  onChange={updateAndValidateOnChange}
                  title="Anrede"
                  name="daten.abwRechnungsempfaenger.anrede.value"
                  labelClassName="colon"
                  className="col-auto"
                  inline
                />
                <FormSelect
                  {...abwRechnungsempfaenger.titel}
                  onChange={updateAndValidateOnChange}
                  title="Titel"
                  inputClassName="input-date"
                  labelClassName="colon"
                  className="col"
                  name="daten.abwRechnungsempfaenger.titel.value"
                />
              </Row>
              <FormInput
                {...abwRechnungsempfaenger.vorname}
                onChange={validateOnChange}
                title="Vorname"
                name="daten.abwRechnungsempfaenger.vorname.value"
                autocomplete="given-name"
                labelClassName="colon"
              />
              <FormInput
                {...abwRechnungsempfaenger.nachname}
                onChange={validateOnChange}
                title="Nachname"
                name="daten.abwRechnungsempfaenger.nachname.value"
                autocomplete="family-name"
                labelClassName="colon"
              />
              <FormMask
                {...abwRechnungsempfaenger.geburtsdatum}
                onChange={validateOnChange}
                title="Geburtsdatum"
                name="daten.abwRechnungsempfaenger.geburtsdatum.value"
                inputClassName="input-date text-center"
                labelClassName="colon"
              />

              <AdresseForm
                postleitzahl={abwRechnungsempfaenger.postleitzahl}
                postleitzahlName="daten.abwRechnungsempfaenger.postleitzahl.value"
                ort={abwRechnungsempfaenger.ort}
                ortName="daten.abwRechnungsempfaenger.ort.value"
                strasse={abwRechnungsempfaenger.strasse}
                strasseName="daten.abwRechnungsempfaenger.strasse.value"
                hausnummer={abwRechnungsempfaenger.hausnummer}
                hausnummerName="daten.abwRechnungsempfaenger.hausnummer.value"
              />

              <FormInput
                {...abwRechnungsempfaenger.zustellvermerk}
                name="daten.abwRechnungsempfaenger.zustellvermerk.value"
                onChange={updateAndValidateOnChange}
                title="Zustellvermerk"
                labelClassName="colon"
              />

              <If predicate={bankVerbindung.iban.relevant}>
                <FormMask
                  {...bankVerbindung.iban}
                  name="daten.bankVerbindung.iban.value"
                  title={i18next.t('iban.titel')}
                  onChange={validateIBANOnChange}
                  inputmask={{
                    mask: 'DE99 9999 9999 9999 9999 99',
                  }}
                  inputMode="numeric"
                />
              </If>
            </Form>
          </If>

          <If predicate={(bankVerbindung.inhaber.relevant || bankVerbindung.iban.relevant) && istNeinAuswahl(abweichenderRE)}>
            <Headline>Zahlungsdaten</Headline>
            <div className="mb-5">
              <BankInhaberFormInput />
              <BankIbanFormKonto />
              <BankIbanFormMask
                onChange={validateIBANOnChange}
              />
              <BankSepaFormCheck
                onChange={updateAndValidateOnChange}
              />
            </div>
          </If>

          <BankBemerkungFormText />

          <DatenschutzFormCheck
            onChange={updateAndValidateOnChange}
          />
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              onNextClick={handleNextClick}
            />
            <SpeicherButton />
          </Col>
        </Row>
      </Col>
      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb />
      </SummingUp>
    </Row>
  );
};

export default Zahlungsdaten;
